export default "__VITE_ASSET__1ed2eaa1__"